/**
 * Content registry — the single source of truth for product facts quoted in
 * marketing, docs and legal copy. Change a number here, it changes everywhere
 * that imports it. `yarn check:facts` (scripts/check_facts.js) fails the build
 * when a page hardcodes a count that contradicts this file.
 */
export const COIN_COUNT = 19;          // unique display assets
export const NETWORK_COUNT = 13;       // supported networks/chains
export const RAIL_COUNT = 37;          // asset × network rails
export const GATEWAY_CODE_COUNT = 14;  // accepted_coins codes on the gateway API
export const FEE_PCT = 0;              // platform fee (%)

// Derived phrasings used verbatim across pages.
export const COINS_MORE_AFTER_4 = COIN_COUNT - 4;   // "btc, eth, usdt, sol + N more"
export const COINS_MORE_AFTER_8 = COIN_COUNT - 8;   // "…, XRP, Tron and N more"
export const COINS_NETWORKS = `${COIN_COUNT} coins · ${NETWORK_COUNT} networks`;
export const COINS_ACROSS = `${COIN_COUNT} coins across ${NETWORK_COUNT} networks`;

// Plan pricing (USD). Legal terms deliberately reference /pricing instead of
// hardcoding numbers; every UI mention must come from here.
export const PLAN_PRICE_MONTHLY = { free: 0, pro: 9, business: 29, scale: 99 };
export const PLAN_PRICE_ANNUAL = { free: 0, pro: 90, business: 290, scale: 990 };
export const PLAN_PRICES_LINE = `$${PLAN_PRICE_MONTHLY.pro} / $${PLAN_PRICE_MONTHLY.business} / $${PLAN_PRICE_MONTHLY.scale} per month`;

// Canonical fee sentence — quote it, don't paraphrase it.
export const FEE_WORDING = `crypt.pe charges ${FEE_PCT}% per transaction — payments settle wallet-to-wallet, so we can't take a cut. Network (gas) fees and optional paid plans still apply.`;

// Dev-time drift alarm: lib/stats.js derives counts from the real coins data;
// if that data changes, this registry must be updated to match.
if (process.env.NODE_ENV !== "production") {
  import("./stats").then((s) => {
    if (s.COIN_COUNT !== COIN_COUNT || s.CHAIN_COUNT !== NETWORK_COUNT) {
      console.error(`facts.js drift — coins data says ${s.COIN_COUNT} coins / ${s.CHAIN_COUNT} chains, facts.js says ${COIN_COUNT}/${NETWORK_COUNT}`);
    }
  });
}
